import React from 'react';
import classNames from 'classnames';
import { SectionSplitProps } from '../../utils/SectionProps';
import SectionHeader from './partials/SectionHeader';
import Image from '../elements/Image';
import { Link } from 'react-router-dom';
import SalesTiles from '../../components/sections/SalesTiles';

const propTypes = {
  ...SectionSplitProps.types
}

const defaultProps = {
  ...SectionSplitProps.defaults
}

const DocumentationView = ({
  className,
  topOuterDivider,
  bottomOuterDivider,
  topDivider,
  bottomDivider,
  hasBgColor,
  invertColor,
  invertMobile,
  invertDesktop,
  alignTop,
  imageFill,
  ...props
}) => {


  const outerClasses = classNames(
    'features-split section',
    topOuterDivider && 'has-top-divider',
    bottomOuterDivider && 'has-bottom-divider',
    hasBgColor && 'has-bg-color',
    invertColor && 'invert-color',
    className
  );

  const innerClasses = classNames(
    'features-split-inner section-inner',
    topDivider && 'has-top-divider',
    bottomDivider && 'has-bottom-divider'
  );

  const splitClasses = classNames(
    'split-wrap',
    invertMobile && 'invert-mobile',
    invertDesktop && 'invert-desktop',
    alignTop && 'align-top'
  );

  const sectionHeader = {
    title: 'Software Product',
    paragraph: "Innovative Electronics with Customizable Software. Find Data Analysis Resources for your Custom Applications."
  };

  return (
    <section
      {...props}
      className={outerClasses}
    >
      <div className="container">
        <div className={innerClasses}>
          <SectionHeader data={sectionHeader} className="center-content" />
          <div className={splitClasses}>

            <div className="split-item">
              <div className="split-item-content center-content-mobile reveal-from-left" data-reveal-container=".split-item">
                <div className="text-xxs text-color-primary fw-600 tt-u mb-8">
                  Your Tiered Product Offering
                </div>
                <h3 className="mt-0 mb-12">
                  Customized for Each Customer Application
                  </h3>




              </div>
            </div>

      <SalesTiles invertMobile topDivider imageFill className="illustration-section-02" />




            <div className="split-item">
              <div className="split-item-content center-content-mobile reveal-from-right" data-reveal-container=".split-item">
                <div className="text-xxs text-color-primary fw-600 tt-u mb-8">
                  Customizable Software
                  </div>
                <h3 className="mt-0 mb-12">
                  Download our Software Today!
                  </h3>
                <p className="m-0">
                  Send Commands to your Hardware to Capture Data 24/7. Develop Processes with Alerts and Warnings.
                  </p>
              </div>
              <div className={
                classNames(
                  'split-item-image center-content-mobile reveal-from-bottom',
                  imageFill && 'split-item-image-fill'
                )}
                data-reveal-container=".split-item">
                <Image
                  src={require('./../../assets/images/1-detailChemId.png')}
                  alt="Data Visualized Raman 01"
                  width={528}
                  height={396} />
              </div>
            </div>





    <div className="split-item">
              <div className="split-item-content center-content-mobile reveal-from-left" data-reveal-container=".split-item">
                <div className="text-xxs text-color-primary fw-600 tt-u mb-8">
                  Community Intelligence
                  </div>
                <h3 className="mt-0 mb-12">
                  Better Decision Making
                  </h3>
                <p className="m-0">
                Collect and Analyze Data, resulting in Real Insights for Better Decision Making. Review Data and Share Analysis Reports. </p>
                <Link to={'/samplereport'} >
                <button className="button button-primary button-wide-mobile button-sm" > View Sample Report </button>
                </Link>
              </div>

            </div>




          </div>
        </div>
      </div>
    </section>
  );
}

DocumentationView.propTypes = propTypes;
DocumentationView.defaultProps = defaultProps;

export default DocumentationView;